import type { DocumentUpload } from '@gcv/shared';
import { useQueryClient } from '@tanstack/react-query';

import { BANK_DISPENSARY_INTERNAL_DOCUMENTS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useFiInternalDocumentsCache(dispensaryId: string) {
  const { userBankId } = useUser();
  const queryClient = useQueryClient();
  const queryKey = [BANK_DISPENSARY_INTERNAL_DOCUMENTS_KEY, userBankId, dispensaryId];

  const addDocumentsToCache = (documents: DocumentUpload[]) => {
    queryClient.setQueryData(queryKey, (existing: DocumentUpload[] | undefined) =>
      (existing ?? []).concat(documents)
    );
  };

  const removeDocumentsFromCache = (docIds: string[]) => {
    queryClient.setQueryData(queryKey, (existing: DocumentUpload[] | undefined) =>
      existing?.filter((doc) => !docIds.includes(doc.id))
    );
  };

  const updateDocumentsInCache = (documents: DocumentUpload[]) => {
    queryClient.setQueryData(queryKey, (existing: DocumentUpload[] | undefined) =>
      existing?.map((doc) => documents.find((updated) => updated.id === doc.id) ?? doc)
    );
  };

  return { addDocumentsToCache, removeDocumentsFromCache, updateDocumentsInCache };
}
